import Icon1 from "../../svgs/gameflow/icons/Icon1";
import Icon2 from "../../svgs/gameflow/icons/Icon2";
import Icon3 from "../../svgs/gameflow/icons/Icon3";
import Icon4 from "../../svgs/gameflow/icons/Icon4";

export const GameflowObjects = [
  {
    icon: <Icon1 />,
    title: "Login with your wallet",
    description:
      "Use Binance RPC as the selected Chain. MetaMask and TrustWallet are supported.",
    mobileIcon: 'images/gameflow/1.png',
  },
  {
    icon: <Icon2 />,
    title: "Mint, Sell NFTs",
    description:
      "NFTs are freely traded on the marketplace for Purge tokens, and the tokens can be freely sold on the DEX.",
    mobileIcon: 'images/gameflow/2.png',
  },
  {
    icon: <Icon3 />,
    title: "Play Matches",
    description: "Once you have an NFT, you are allowed to play matches.",
    mobileIcon: 'images/gameflow/3.png',
  },
  {
    icon: <Icon4 />,
    title: "Awards",
    description:
      "Every week there will be a weekly leaderboard with awards to win.",
    mobileIcon: 'images/gameflow/4.png',
  },
];